// ============================================================================
// Дизайн-система OZ DAO — JS-энтрипоинт
// ============================================================================
// Единая точка входа: стили + компоненты.
//
// Подключение стилей в проекте (один раз, в client.js, ДО собственной темы):
//   import '@ozdao/martyrs/src/design-system/index.js';
//   import '@/design-system/theme.scss'; // тема проекта — unlayered, бьёт слои DS
//
// Инициализация бренда — БЕЗ JS-конфига: вся тема = значения CSS-токенов,
// проект переопределяет их в своём theme.scss (как Tailwind v4 @theme / shadcn
// :root-vars). JS-фабрики (createVuetify/definePreset) нужны только библиотекам,
// генерирующим CSS из JS в рантайме — у нас CSS уже статический.
//
// Импорт компонентов — ТОЛЬКО deep imports (tree-shaking):
//   import Button from '@martyrs/src/design-system/components/Button/Button.vue';
//
// Путь './src/*' в exports martyrs резолвится в ИСХОДНИКИ и в dev, и в prod —
// стили и компоненты компилируются сборщиком проекта единообразно, без dist.
import './styles/index.scss';

import { theme } from './utils/theme.js';
import { display } from './utils/display.js';
import { token } from './utils/token.js';
import revealPlugin from './plugins/reveal.plugin.js';

// Компоненты здесь НЕ реэкспортируются: `import { ds }` не должен тянуть баррель
// (sideEffects "*.vue" включил бы ВСЕ компоненты в бандл). Компоненты — deep imports,
// баррель для совместимости — src/main.js.
export { theme, display, token, revealPlugin };

// Неймспейс дизайн-системы: ds.theme.toggle(), ds.display.mobile, ds.token('main')
export const ds = { theme, display, token };
